<tiime-input-container
  [small]="small"
  contentId="accountingPeriodSelect"
  [label]="label"
  [errorMessage]="errorMessage?.message"
  [required]="required"
>
  <tiime-select
    data-cy="accounting-period-select"
    id="accountingPeriodSelect"
    [placeholder]="placeholder"
    [formControl]="accountingPeriodFilter"
    tiimeTooltip
    tooltipPosition="right"
    [tooltipContent]="selectedTooltipTemplate"
    tooltipClass="tiime-tooltip"
    [tooltipDisabled]="!(accountingPeriodFilter.value | map: mapToShowTooltip : withCustom)"
    [customFindOriginValueFromOptions]="findAccountingPeriodInSelect"
  >
    @if (accountingPeriodFilter.value | map: mapToClosedIcon; as icon) {
      <mat-icon tiimeSelectSuffix class="locked-icon" fontSet="fontastic" [fontIcon]="icon" inline="true"></mat-icon>
    }
    @if (accountingPeriodFilter.value | map: mapToIsCustom : withCustom) {
      <mat-icon
        tiimeSelectSuffix
        class="locked-icon"
        fontSet="fontastic"
        fontIcon="icon-calendar"
        inline="true"
      ></mat-icon>
    }
    @if (accountingPeriodFilter.value | map: mapToIsClosing) {
      <app-loading-icon tiimeSelectSuffix>
        <mat-icon loading-icon inline="true" fontSet="fontastic" fontIcon="icon-ic-lock-1" />
      </app-loading-icon>
    }
    <div tiimeSelectOptions>
      @if (withCustom) {
        <div class="divider custom-accounting-period-divider">
          Période personnalisée
          @if (!(accountingPeriods | map: mapToCustomAccountingPeriod)) {
            <button
              tiime-button
              color="primary"
              icon
              title="Ajouter une période personnalisée"
              (click)="openEditCustomAccountingPeriodDialog()"
            >
              <mat-icon fontSet="fontastic" fontIcon="icon-ic-add-1"></mat-icon>
            </button>
          } @else {
            <button
              tiime-button
              color="primary"
              icon
              title="Supprimer la période personnalisée"
              (click)="deleteCustomAccountingPeriod()"
            >
              <mat-icon fontSet="fontastic" fontIcon="icon-ic-remove"></mat-icon>
            </button>
          }
        </div>
        @if (accountingPeriods | map: mapToCustomAccountingPeriod; as customAccountingPeriod) {
          <mat-option [value]="customAccountingPeriod">
            <div class="option-wrapper">
              @if (endDateOnly) {
                {{ customAccountingPeriod.endDate | date: 'shortDate' }}
              } @else {
                Du {{ customAccountingPeriod.startDate | date: 'shortDate' }} au
                {{ customAccountingPeriod.endDate | date: 'shortDate' }}
              }
              <mat-icon fontSet="fontastic" fontIcon="icon-calendar"></mat-icon>
            </div>
          </mat-option>
        }
      }
      <div class="divider">Exercices</div>
      @if (allowEmpty) {
        <mat-option [value]="null"></mat-option>
      }
      @for (accountingPeriod of accountingPeriods; track $index) {
        @if (!accountingPeriod.custom) {
          <mat-option [value]="accountingPeriod">
            <div class="option-wrapper">
              @if (endDateOnly) {
                {{ accountingPeriod.endDate | date: 'shortDate' }}
              } @else {
                Du {{ accountingPeriod.startDate | date: 'shortDate' }} au
                {{ accountingPeriod.endDate | date: 'shortDate' }}
              }
              @if (accountingPeriod.closed && accountingPeriod.asyncProcessType !== AsyncProcessType.closing) {
                <mat-icon fontSet="fontastic" fontIcon="icon-ic-lock-1"></mat-icon>
              }
              @if (accountingPeriod.asyncProcessType === AsyncProcessType.closing) {
                <app-loading-icon>
                  <mat-icon loading-icon fontSet="fontastic" fontIcon="icon-ic-lock-1" />
                </app-loading-icon>
              }
            </div>
          </mat-option>
        }
      }
    </div>
  </tiime-select>
  <ng-template #selectedTooltipTemplate>
    @if (accountingPeriodFilter?.value; as accountingPeriodFilterValue) {
      @if (accountingPeriodFilterValue.closed) {
        L'exercice est clôturé
      }
      @if ((accountingPeriodFilterValue | map: mapToIsCustom : withCustom) && accountingPeriodFilterValue?.closed) {
        <br />
      }
      @if (accountingPeriodFilterValue | map: mapToIsCustom : withCustom) {
        Vous visualisez une période personnalisée
      }
    }
  </ng-template>
</tiime-input-container>
